import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchDiagnoseCount = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/diagnose-case-round/count-results", filterData);
            if (countRes.data && countRes.data.succeeded && countRes?.data?.result?.data ) {
                return countRes.data.result.data;
            }
            if (!countRes.data || !countRes.data.succeeded) {
                snackActions.snackBar({
                    message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnoses."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnoses."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchDiagnoseList = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post("/diagnose-case-round/list-results", filterData);
            if (res.data && res.data.succeeded && res?.data?.result?.data) {
                return res.data.result.data || [];
            }
            if (!res.data || !res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : "Cannot fetch diagnoses."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnoses."}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const clearDiagnoseResultsPerDiagnoseCases = (params) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            const res = await rest.post("/diagnose-case-round/clear-results-per-diagnose-cases", params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: res.data.message || `Clear diagnose results per diagnose cases was successful.`,
                    options: {
                        variant: "success",
                    },
                });
                return;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot clear diagnose results."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const clearDiagnoseResultsPerProducts = (params) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            const res = await rest.post("/diagnose-case-round/clear-results-per-products", params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: res.data.message || `Clear diagnose results per products was successful.`,
                    options: {
                        variant: "success",
                    },
                });
                return;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot clear diagnose results."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};